export var NavControllCommand = function(navCmd, navPanel){
	this.navCmd = navCmd;
	this.navPanel = navPanel;
}
NavControllCommand.prototype = {
	constructor : NavControllCommand,
	exec : function(scope){
		if (this.navCmd === 0){
			if(scope.sceneManager.roadNav.airMode==1){
				scope.carTips();
				return
			}
			scope.sceneManager.roadNav.stop();
			// this.navPanel.playIcon = '/static/bimroad/imgs/player_play.png'
            this.navPanel.player = 'play';
		}
		else if (this.navCmd === 1){
			if (scope.sceneManager.roadNav.state == 0){
				scope.sceneManager.roadNav.initCarMode();
				scope.sceneManager.roadNav.start(this.navPanel.carSpeed);	
				this.navPanel.player = 'pause';
			}
			else if (scope.sceneManager.roadNav.state == 1){
				if(scope.sceneManager.roadNav.airMode==1){
					scope.carTips();
					return
				}
				scope.sceneManager.roadNav.pause();	
				this.navPanel.player = 'play';
			}
			else{
				if(scope.sceneManager.roadNav.airMode==1){
					scope.carTips();
					return
				}
				scope.sceneManager.roadNav.resume();
				this.navPanel.player = 'pause'
			}
			

		}
		else if (this.navCmd ===2){
			if(scope.sceneManager.roadNav.airMode==1){
				scope.carTips();
				return
			}
			scope.sceneManager.roadNav.incSpeed();
			this.navPanel.carSpeed = scope.sceneManager.roadNav.getSpeed();
		}
		else if (this.navCmd ===3){
			if(scope.sceneManager.roadNav.airMode==1){
				scope.carTips();
				return
			}
			scope.sceneManager.roadNav.decSpeed();
			this.navPanel.carSpeed = scope.sceneManager.roadNav.getSpeed();
		}
		else if (this.navCmd === -1){
			this.navPanel.showSelf = true;
		}
		else if (this.navCmd === 4){
			if(scope.sceneManager.roadNav.airMode==1){
				scope.carTips();
				return
			}
			if (scope.sceneManager.activeCamera === scope.sceneManager.camera){
			      this.navPanel.inCar = 'inCar';
			 }
			 else{
			      this.navPanel.inCar = 'notInCar';
			 }
			scope.sceneManager.switchCamera();
		}
	}
}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/NavControllCommand.js